module.exports = __webpack_public_path__ + "img/GP logo.49454848.png";